import React from 'react';
import styles from './Pagination.module.css';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
    const getPageNumbers = () => {
        const pageNumbers: (number | string)[] = [];
        
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
            return pageNumbers;
        }
        
        pageNumbers.push(1);
        
        if (currentPage <= 4) {
            for (let i = 2; i <= 5; i++) {
                pageNumbers.push(i);
            }
            pageNumbers.push('...');
            pageNumbers.push(totalPages);
        } 
        else if (currentPage >= totalPages - 3) {
            pageNumbers.push('...');
            for (let i = totalPages - 4; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } 
        else {
            pageNumbers.push('...');
            for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                pageNumbers.push(i);
            }
            pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        
        return pageNumbers;
    };
    
    const progressPercentage = Math.min(100, Math.round((currentPage / totalPages) * 100));
    
    return (
        <div className={styles.paginationContainer}>
            <div className={styles.progressBarContainer}>
                <div className={styles.progressBarBackground}>
                    <div 
                        className={styles.progressBarFill} 
                        style={{ width: `${progressPercentage}%` }}
                    />
                </div>
            </div>
            <div className={styles.paginationControls}>
                <button 
                    className={styles.arrowButton} 
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    &lt;
                </button>
                <div className={styles.pageNumbers}>
                    {getPageNumbers().map((page, index) => (
                        page === '...' ? (
                            <span key={`ellipsis-${index}`} className={styles.ellipsis}>...</span>
                        ) : (
                            <button
                                key={`page-${page}`}
                                className={`${styles.pageButton} ${currentPage === page ? styles.active : ''}`}
                                onClick={() => onPageChange(page as number)}
                            >
                                {page}
                            </button>
                        )
                    ))}
                </div>
                <button 
                    className={styles.arrowButton} 
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    &gt;
                </button>
            </div>
        </div>
    );
};
